import { START_LOADING } from 'redux/modules/multi-search/actions/types';

export const startLoading = () => ({
  type: START_LOADING,
});
